import { actionCreatorFactory } from 'typescript-fsa';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IChartMetadata, ISupersetChartListItem } from './superset.interface';

export namespace SupersetAction {
  const actionCreator = actionCreatorFactory('SUPERSET');

  export const loadChartList = actionCreator.async<void, ISupersetChartListItem[], IApiErrorParams>('LOAD_CHART_LIST');

  export interface ILoadChartMetadataParams {
    sliceId: number;
    columnOverrides?: Partial<Record<string, Partial<GridColDef>>>;
  }

  export const loadChartMetadata = actionCreator.async<
    ILoadChartMetadataParams,
    IChartMetadata,
    IApiErrorParams
  >('LOAD_CHART_METADATA');

  export const updateColumnsMetadata = actionCreator<{ sliceId: number; columns: GridColDef[] }>('UPDATE_COLUMNS_METADATA');

  export const loadRowCount = actionCreator<{
    sliceId: number;
    totalRowCount: number;
    filteredRowCount: number;
  }>('LOAD_ROW_COUNT');
}
